export const globals = {
  locales: {
    'en-US': 'In english',
    'fi-FI': 'Suomeksi',
  },
}
